module.exports = __webpack_public_path__ + "img/people.f6877a7d.svg";